// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
function debounce(func, wait, immediate) {
	var timeout;
	return function() {
		var context = this, args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};

$(window).bind('load', function() {

	// If we are on the single product template
	if ( $('body').hasClass('single-products') ) {

		// Set the “active state underline” to same with as first link
		$('.product-nav-underline').css({
			'width': $('.product-nav ul li:first-child a').width() + 'px'
		});

		var checkScrollBlocks = debounce(function() { // Debounce for performance
			// Work out horizontal offset of technical link
			if ( $('a#technical-trigger').length > 0 ) {
				var technicalTriggerOffset = $('a#technical-trigger').position();
				var technicalTriggerX = technicalTriggerOffset.left;
			}

			// Work out horizontal offset of resources link
			var resourcesTriggerOffset = $('a#resources-trigger').position();
			var resourcesTriggerX = resourcesTriggerOffset.left;

			// Work out horizontal offset of similar products link
			if ( $('a#similar-trigger').length > 0 ) {
				var similarTriggerOffset = $('a#similar-trigger').position();
				var similarTriggerX = similarTriggerOffset.left;
			}

			// Work out vertical offset of technical content
			if ( $('section#technical').length > 0 ) {
				var technicalOffset = $('section#technical').offset();
				var technicalStart = technicalOffset.top;
			}

			// Work out vertical offset of resources content
			var resourcesOffset = $('section#resources').offset();
			var resourcesStart = resourcesOffset.top;

			// Work out vertical offset of similar products content
			if ( $('section#similar').length > 0 ) {
				var similarOffset = $('section#similar').offset();
				var similarStart = similarOffset.top;
			}

			// visual scroll position, which is window plus the sticky bar
			var windowScrollOffset = $(window).scrollTop() + $('.product-nav').height();

			// check scroll position and move “active state underline” accordingly
			if ( windowScrollOffset >= similarStart - 130 ) {
				$('.product-nav-underline').css({
					'transform': 'translateX(' + similarTriggerX + 'px)',
					'width': $('a#similar-trigger').width() + 'px'
				});
			} else if ( windowScrollOffset >= resourcesStart - 130 ) {
				$('.product-nav-underline').css({
					'transform': 'translateX(' + resourcesTriggerX + 'px)',
					'width': $('a#resources-trigger').width() + 'px'
				});
			} else if ( windowScrollOffset >= technicalStart - 130 ) {
				$('.product-nav-underline').css({
					'transform': 'translateX(' + technicalTriggerX + 'px)',
					'width': $('a#technical-trigger').width() + 'px'
				});
			} else {
				$('.product-nav-underline').css({
					'transform': 'translateX(0px)',
					'width': $('a#overview-trigger').width() + 'px'
				});
			}

		}, 10);
		
		window.addEventListener('scroll', checkScrollBlocks);
		window.addEventListener('resize', checkScrollBlocks);

	}

});
